export default "__VITE_ASSET__C9n__GlE__"